export enum StudyBundleCourseStatusType {
    NOT_STARTED = 'NOT_STARTED',
    IN_PROGRESS = 'ACTIVE',
    COMPLETE = 'COMPLETE',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/StudyBundleCourseStatusType.ts